import { AnalysisActionType } from '@modules/analysis/types';

export const isAddToDashboardButtonDisabled = (
  actionType: AnalysisActionType,
  hasChangesToBeSaved: boolean,
) => {
  const isValidActionType =
    actionType === AnalysisActionType.SAVE_UPDATE ||
    actionType === AnalysisActionType.SAVE_AS;

  return isValidActionType && hasChangesToBeSaved;
};
